import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {ConfigService } from 'app/services';
import {MenuHomeEnum} from 'app/home';
import {Subscription} from 'rxjs';
import {MenuService} from 'app/finance/finance-payout/menu-service';

@Component({
    selector: 'finance-payout',
    templateUrl: './finance-payout.component.html',
    styleUrls: ['./finance-payout.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class FinancePayoutComponent implements OnInit, OnDestroy {
    @Input()
    public menuPermissionActive!: string;

    menuHomeEnumActive: MenuHomeEnum | undefined;
    onboardingTabMenu: any = [
        {
            name: 'Cebuana Otc',
            value: MenuHomeEnum.CebuanaPayout
        },
        {
            name: 'Online Transfer',
            value: MenuHomeEnum.OnlineTransfer
        }
    ];
    _menuHomeEnum = MenuHomeEnum;
    $subscription: Subscription | undefined;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_finance' }, { label: 'Finances' }, { label: 'Accounting' }, { label: 'Payout' }];

    constructor(
        public configService: ConfigService,
        private menuService: MenuService) {
    }

    ngOnInit(): void {
        this.$subscription = this.menuService.menuHomeEnumActive$.subscribe(
            (value) => {
                this.menuHomeEnumActive = value;
            }
        );
    }

    ngOnDestroy(): void {
        this.$subscription?.unsubscribe();
    }
}
